import { render, staticRenderFns } from "./LabResult.vue?vue&type=template&id=67fd511d&"
import script from "./LabResult.vue?vue&type=script&lang=ts&"
export * from "./LabResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports